import Image from '@anm/components/image/Image';
import { device } from '@anm/styles/helpers';
import styled from 'styled-components';
export var Wrapper = styled.div.withConfig({
  componentId: "sc-1vd3gdg-0"
})(["padding:30px 10px 68px 10px;background:rgba(145,158,170,0.1);@media ", "{padding-top:19px;padding-bottom:39px;}"], device.laptop);
export var LogoWrapper = styled(Image).withConfig({
  componentId: "sc-1vd3gdg-1"
})(["margin-left:5px;"]);
export var TextWrapper = styled.div.withConfig({
  componentId: "sc-1vd3gdg-2"
})(["display:flex;align-items:center;justify-content:center;font-size:14px;line-height:22px;color:#919eaa;p{margin:0;}", ""], function (_ref) {
  var fontStyles = _ref.fontStyles;
  return fontStyles && "".concat(fontStyles);
});